import { render } from "./CollapseTransition.vue?vue&type=template&id=0b4f5d85&scoped=true"
import script from "./CollapseTransition.vue?vue&type=script&lang=js"
export * from "./CollapseTransition.vue?vue&type=script&lang=js"

import "./CollapseTransition.vue?vue&type=style&index=0&id=0b4f5d85&scoped=true&lang=css"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4f5d85"]])

export default __exports__